var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
import React, { memo, useCallback } from 'react';
import { uuid } from '@web/utils';
import { styled } from '@web/theme';
import { useAuth } from '../../../ModuleAuth';
import { usePage } from '../../';
import { Fab } from '../../../Button';
import { useAccount } from '../../../ModuleAccount';
import { userRoles } from '../../../ModuleApp';
import { BlockType } from '../../../ModuleBlock';
import { useFirebase } from '@web/firebase';
export var PageUpgrade = memo(function () {
    var auth = useAuth().auth;
    var account = useAccount().account;
    var data = usePage().page.data;
    var _a = useFirebase(), addOrUpdateBlock = _a.addOrUpdateBlock, addOrUpdatePage = _a.addOrUpdatePage;
    var upgradePage = useCallback(function () {
        var _a, _b, _c, _d;
        if (data.version === undefined) {
            var _id = uuid();
            var blocks_1 = {
                top: [],
                right: [],
                bottom: [],
                left: [],
                main: []
            };
            var blockData_1 = { _type: BlockType.TEXT, margin: false, shadow: false, deleted: false };
            var mainBlock = __assign(__assign({}, blockData_1), { _id: _id, _title: data.id.toUpperCase(), text: data.content });
            addOrUpdateBlock({ _id: _id, data: mainBlock });
            blocks_1.main = __spreadArray(__spreadArray([], blocks_1.main), [mainBlock._id]);
            if ((_a = data === null || data === void 0 ? void 0 : data.boxAreas) === null || _a === void 0 ? void 0 : _a.before)
                data.boxAreas.before.map(function (box, index) {
                    var block = __assign(__assign({}, blockData_1), { _id: box.id, _title: data.id.toUpperCase() + "-top-" + index, text: box.content });
                    addOrUpdateBlock({ _id: block._id, data: block });
                    blocks_1.top = __spreadArray(__spreadArray([], blocks_1.top), [block._id]);
                });
            if ((_b = data === null || data === void 0 ? void 0 : data.boxAreas) === null || _b === void 0 ? void 0 : _b.after)
                data.boxAreas.after.map(function (box, index) {
                    var block = __assign(__assign({}, blockData_1), { _id: box.id, _title: data.id.toUpperCase() + "-bottom-" + index, text: box.content });
                    addOrUpdateBlock({ _id: block._id, data: block });
                    blocks_1.bottom = __spreadArray(__spreadArray([], blocks_1.bottom), [block._id]);
                });
            if ((_c = data === null || data === void 0 ? void 0 : data.boxAreas) === null || _c === void 0 ? void 0 : _c.left)
                data.boxAreas.left.map(function (box, index) {
                    var block = __assign(__assign({}, blockData_1), { _id: box.id, _title: data.id.toUpperCase() + "-left-" + index, text: box.content });
                    addOrUpdateBlock({ _id: block._id, data: block });
                    blocks_1.left = __spreadArray(__spreadArray([], blocks_1.left), [block._id]);
                });
            if ((_d = data === null || data === void 0 ? void 0 : data.boxAreas) === null || _d === void 0 ? void 0 : _d.right)
                data.boxAreas.right.map(function (box, index) {
                    var block = __assign(__assign({}, blockData_1), { _id: box.id, _title: data.id.toUpperCase() + "-right-" + index, text: box.content });
                    addOrUpdateBlock({ _id: block._id, data: block });
                    blocks_1.right = __spreadArray(__spreadArray([], blocks_1.right), [block._id]);
                });
            addOrUpdatePage({ _id: data.id, data: { blocks: blocks_1, version: 2 } });
        }
    }, [data]);
    if (!auth.user || account.role !== userRoles.type.admin || (data.version !== undefined && data.version > 1))
        return null;
    return (React.createElement(Wrapper, null,
        React.createElement(Fab, { onClick: upgradePage, cta: true }, "Aktualizovat str\u00E1nku na nejnov\u011Bj\u0161\u00ED verzi?")));
});
var Wrapper = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  z-index: 920;\n  position: absolute;\n  bottom: .5em;\n  right: 10em;\n  display: flex;\n  transition: display 1s;\n  // background: black;\n  padding: .25em;\n  \n  &:hover {\n\tz-index: 999;\n  }\n"], ["\n  z-index: 920;\n  position: absolute;\n  bottom: .5em;\n  right: 10em;\n  display: flex;\n  transition: display 1s;\n  // background: black;\n  padding: .25em;\n  \n  &:hover {\n\tz-index: 999;\n  }\n"])));
var templateObject_1;
